import { IConvenienceItemConfig } from "config/conveniences";
import { DISPOSITIONS, IDispositionItemConfig } from "config/dispositions";
import { IFurnishingItemConfig } from "config/furnishing";
import { IOfferAgeItemConfig } from "config/offerAge";
import { IOfferSortingItemConfig } from "config/offerSorting";
import { IGeoBounds } from "utils/geo";
import NumericInterval from "utils/NumericInterval";
import {
  EApiConvenienceId,
  EApiDispositionId,
  EApiFurnishingId,
  EApiSpecialFlag,
  EOfferTypeId,
} from "utils/offer";

export interface ISearchFilterState {
  dispositions: Array<IDispositionItemConfig>;
  price: NumericInterval;
  area: NumericInterval;
  furnishing: Array<IFurnishingItemConfig>;
  conveniences: Array<IConvenienceItemConfig>;
  isBalcony: boolean | null;
  offerAge: IOfferAgeItemConfig;
  bounds?: IGeoBounds;
  sorting: IOfferSortingItemConfig;
  pageIndex: number;
  noCommitionFee: boolean | null;
  specialFlag: EApiSpecialFlag | null;
  offerTypeId?: EOfferTypeId;
}

export interface IWatchdogState {
  acreageFrom: number | null;
  acreageTo: number | null;
  bounds: IGeoBounds;
  furnishing: Array<EApiFurnishingId>;
  conveniences: Array<EApiConvenienceId>;
  offerTypeId: number;
  priceFrom: number;
  priceTo: number;
  dispositions: Array<EApiDispositionId>;
  isPriceCommisionFree?: boolean;
}

export const dispositionsOptions = DISPOSITIONS.filter(
  (disposition) => disposition.availableInSearch,
).map((disposition) => ({
  value: disposition.queryValue,
  label: disposition.translationId,
}));
